let hideMoney = false;
export const setHideMoney = (v) => { hideMoney = v; };
export const showMoney = () => !hideMoney;

export const eur = (n) => hideMoney ? "" :
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

// Costo materie prime: visibile anche senza dati finanziari
export const materialCost = (n) => new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n) || 0);

export const num = (n) => new Intl.NumberFormat("it-IT").format(Number(n) || 0);

export const shortDate = (iso) => {
  if (!iso) return "-";
  try {
    return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

import { startOfMonth, endOfMonth, format as fmtDate, differenceInCalendarDays, subDays, subMonths } from "date-fns";

export const currentMonthRange = () => ({
  from: startOfMonth(new Date()),
  to: endOfMonth(new Date()),
});

export const previousRange = (range) => {
  if (!range || !range.from || !range.to) return null;
  const from = new Date(range.from);
  const today = new Date();
  // Se il periodo include oggi si confrontano solo i giorni già trascorsi
  const to = from <= today && new Date(range.to) > today ? today : new Date(range.to);
  if (differenceInCalendarDays(new Date(range.to), from) < 31) {
    return { from: subMonths(from, 1), to: subMonths(to, 1) };
  }
  const days = differenceInCalendarDays(to, from) + 1;
  return { from: subDays(from, days), to: subDays(from, 1) };
};

export const toISODate = (d) => (d ? fmtDate(d, "yyyy-MM-dd") : undefined);

export const dateParams = (range) =>
  range && range.from && range.to
    ? { date_from: toISODate(range.from), date_to: toISODate(range.to) }
    : {};

export function formatApiError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
